import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_SUBMIT_RENTER_PROFILE } from 'api/actionTypes';

export default async function submitRenterProfile({ state, apiClient }, params) {
  const { userId, householdApplication, sendSlackMessage } = params;

  typeCheck('userId::PositiveNumber', userId);
  typeCheck('householdApplication::NonEmptyObject', householdApplication);
  typeCheck('sendSlackMessage::Maybe Boolean', sendSlackMessage);

  const submitApplicationResult = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_SUBMIT_RENTER_PROFILE,
    queryId: String(userId),
    state: state,
    payload: {
      userId,
      householdApplication,
      sendSlackMessage,
    },
    onSuccess(renterProfile) {
      state.set(['household', 'renterProfilesByUserId', userId], renterProfile);
    },
  });
  return submitApplicationResult;
}
